declare const Swiper: any;

import * as $ from "jquery";

export default class Sliders {
	constructor() {
		$('.swiper-container').each((i, el) => {
			const swiper = new Swiper(el, {
				loop: true,
				navigation: {
					prevEl: ".swiper-prev",
					nextEl: ".swiper-next"
				}
			});
		});
	}
}